import {CheckIcon} from '@primer/octicons-react'
import {ForYouItem} from '../shared/ForYouItem'
import {useReviewers} from '../../data/use-reviewers'
import {CompletedReviewRow} from './shared/CompletedReviewRow'
import {ReviewHeaderTitle} from './shared/ReviewHeaderTitle'
import {ReviewHeaderDescription} from './shared/ReviewHeaderDescription'
import {ForYouLeadingIcon} from '../shared/ForYouLeadingIcon'

export function Approved() {
  const {data: reviewers} = useReviewers()

  const approvedReviews = reviewers.completedReviews?.filter(review => review.state === 'approved') ?? []

  if (approvedReviews.length === 0) {
    return null
  }

  return (
    <ForYouItem
      leadingVisual={<ForYouLeadingIcon icon={CheckIcon} variant="success" />}
      title={<ReviewHeaderTitle reviews={approvedReviews} state="approved" />}
      ariaLabel={`${approvedReviews.length} ${approvedReviews.length === 1 ? 'approval received' : 'approvals received'}`}
      itemName="approved"
      description={<ReviewHeaderDescription reviews={approvedReviews} />}
    >
      {/* eslint-disable-next-line jsx-a11y/no-redundant-roles */}
      <ul className="list-none p-0" role="list">
        {approvedReviews.map(review => (
          <CompletedReviewRow key={review.id} review={review} />
        ))}
      </ul>
    </ForYouItem>
  )
}
